import API from "../api/axios";

// ─── Get All Followups ───
export const getAllFollowups = () => {
   return API.get("/followups-all");
};

// ─── Get Followup Summary ───
export const getFollowupSummary = () => {
   return API.get("/followups-summary");
};

// ─── Get Single Followup ───
export const getFollowupById = (id) => {
   return API.get(`/followups/${id}`);
};

// ─── Create Followup ───
export const createFollowup = (data) => {
   return API.post("/followups", data);
};

// ─── Update Followup ───
export const updateFollowup = (id, data) => {
   return API.put(`/followups/${id}`, data);
};

// ─── Delete Followup ───
export const deleteFollowup = (id) => {
   return API.delete(`/followups/${id}`);
};